export default {
    getUrl(imageId, type, cropped) {
        var url = "";
        if (imageId && imageId.length > 0) {
            cropped = cropped ? 1 : 0;
            url = process.env.VUE_APP_API_BASE_URL + "viewImage.php?type=" + type + "&id=" + imageId + "&cropped=" + cropped;
        }
        return url;
    },

    getProjectUrl(eventId, projectId) {
        var url = "";
        if (eventId && eventId.length > 0 && projectId && projectId.length > 0) {
            url = process.env.VUE_APP_API_BASE_URL + "viewImage.php?type=event-cover&id=" + projectId + "&eventId=" + eventId;
        }
        return url;
    },

    getProjectThumbUrl(imageId) {
        var url = "";
        if (imageId) {
            url = process.env.VUE_APP_API_BASE_URL + "viewImage.php?type=thumb&id=" + imageId;
        }
        return url;
    },

    getImageWithWatermarkUrl(imageId, watermark) {
        var url = "";
        if (imageId && imageId.length > 0) {
            url = process.env.VUE_APP_API_BASE_URL + "viewImage.php?type=event-with-watermark" + "&id=" + imageId;
            for (var key in watermark) {
                if (Object.prototype.hasOwnProperty.call(watermark, key)) {
                    url += "&" + key + "=" + encodeURIComponent(watermark[key]);
                }
            }
        }
        return url;
    },

    getTargetRatioForImage(image, targetRatio) {
        if (image.width < image.height) {
            targetRatio = 1 / targetRatio;
        }
        return targetRatio;
    },

    calculateCrop: function (image, forceRecalc) {
        var imgW = parseInt(image.width);
        var imgH = parseInt(image.height);

        var swap;
        var orientationInDegrees = image.extraRotation;
        var swapDim = [90, 270].indexOf(orientationInDegrees) > -1;
        if (swapDim) {
            swap = imgW;
            imgW = imgH;
            imgH = swap;
        }

        var targetRatio = image.targetRatio;

        //-- EarlTP - 28-09-2017: ratio calcolato sempre w/h
        var imgRatio = parseFloat(imgW / imgH);
        var validCrop = Array.isArray(image.crop) && (image.crop.length === 4) && !((image.crop[0] === 0) && (image.crop[1] === 0) && (image.crop[2] === 0) && (image.crop[3] === 0)) && !(image.crop[2] * image.crop[3] === 0);

        //--Rut - 14/09/2016 - se sono state salvate coordinate errate vengono fatte ricalcolare
        var recalcCrop = forceRecalc || !validCrop;

        //--Rut - 01/12/2016 - 'aggiustamento' per crop errati che eventualmente sono stati salvati
        if (!recalcCrop) {
            if (image.crop[2] > (swapDim ? imgH : imgW)) {
                image.crop[2] = (swapDim ? imgH : imgW);
                recalcCrop = true;
            }

            if (image.crop[3] > (swapDim ? imgW : imgH)) {
                image.crop[3] = (swapDim ? imgW : imgH);
                recalcCrop = true;
            }

            // Se non sono cambiate le dimensioni di crop, controlla semplicemente i bounds
            if (!recalcCrop) {
                if ((image.crop[0] + image.crop[2]) > (swapDim ? imgH : imgW)) {
                    image.crop[0] = imgW - image.crop[2];
                }
                if ((image.crop[1] + image.crop[3]) > (swapDim ? imgW : imgH)) {
                    image.crop[1] = imgH - image.crop[3];
                }
            }
        }

        if (recalcCrop) {
            // Calcolo crop in base alla dimensione e all'orientamento
            // Crop di default se la foto ha già un ratio uguale al target del progetto: foto intera
            var x = 0, y = 0, w = imgW, h = imgH;

            //--Rut - 19/10/2016 - per immagini del fotolibro, il ratio viene passato nullo e indica di lasciare
            // il crop intero sull'immagine
            if (targetRatio !== null && imgRatio !== targetRatio) {
                //--Rut - 26/10/2017 - ALGORITMO COMPLETO CHE TIENE CONTO DI TUTTI I CASI POSSIBILI
                // (Immagini portrait applicate a 'buchi' landascape, immagini portrati su 'buchi' portrait,
                // e viceversa, ecc.
                // Per provare: occorre fare progetti gitfing sia landscape (come mousepad) che portrait
                // (come cover) e, per ognuno, 'appiccicare' foto di diversa orientation e diverso ratio
                if (imgRatio <= 1) {
                    //******************************************************************
                    // TAGLIO IMMAGINI PORTRAIT
                    //******************************************************************

                    if (targetRatio < 1) {
                        //###############################
                        //CASO PORTRAIT CON BUCO PORTRAIT
                        //###############################

                        if (imgRatio <= targetRatio) {
                            // IMMAGINI PORTRAIT PIù STRETTE E ALLUNGATE DEL BUCO: MANTENGONO LARGHEZZA E
                            // POSSONO 'SCORRERE' IN BASSO O IN ALTO COL CROP
                            h = parseInt(imgW / targetRatio);
                            y = parseInt((imgH - h) / 2);
                        } else {
                            // IMMAGINI PORTRAIT PIù LARGHE E ACCORCIATE RISPETTO AL BUCO: MANTENGONO ALTEZZA
                            // E POSSONO 'SCORRERE' A DESTRA O SINISTRA COL CROP
                            w = parseInt(imgH * targetRatio);
                            x = parseInt((imgW - w) / 2);
                        }
                    } else {
                        //#########################################################################
                        //CASO PORTRAIT CON BUCO LANDSCAPE
                        // Mantiene sempre la larghezza e può scorrere in alto o in basso col crop
                        //#########################################################################
                        h = parseInt(imgW / targetRatio);
                        y = parseInt((imgH - h) / 2);
                    }

                } else {
                    //******************************************************************
                    // TAGLIO IMMAGINI LANDSCAPE
                    //******************************************************************

                    if (imgRatio <= targetRatio) {
                        // IMMAGINI LANDSCAPE PIù STRETTE E ALLUNGATE DEL BUCO: MANTENGONO LARGHEZZA E
                        // POSSONO 'SCORRERE' IN BASSO O IN ALTO COL CROP
                        h = parseInt(imgW / targetRatio);
                        y = parseInt((imgH - h) / 2);
                    } else {
                        // IMMAGINI LANDSCAPE PIù LARGHE E ACCORCIATE RISPETTO AL BUCO: MANTENGONO ALTEZZA
                        // E POSSONO 'SCORRERE' A DESTRA O SINISTRA COL CROP
                        // ************* è ANCHE IL CASO DEL BUCO PORTRAIT NELL'IMMAGINE LANDSCAPE ********
                        w = parseInt(imgH * targetRatio);
                        x = parseInt((imgW - w) / 2);
                    }
                }
            }

            //Salvataggio coordinate di crop nell'array
            var crop = [x, y, w, h];

            //-- Se è presente una extrarotazione le riporto all'alta risoluzione
            if (image.extraRotation > 0) {
                crop = this.rotateCrop(crop, image.width, image.height, image.extraRotation);
            }

            image.crop = crop;
            //-- Ricalcolo le coordinate a bassa risoluzione
            image["lres-crop"] = this.calculateLresCrop(image);
        }

        return image;
    },

    calculateLresCrop: function (image) {
        var x1H = parseInt(image.crop[0]);
        var y1H = parseInt(image.crop[1]);
        var x2H = parseInt(image.crop[2]);
        var y2H = parseInt(image.crop[3]);

        var widthHres = parseInt(image.width);
        var heightHres = parseInt(image.height);
        var widthLres = parseInt(image["lres-width"]);
        var heightLres = parseInt(image["lres-height"]);

        // Rapporto fra alta e bassa risoluzione
        var thumbProp = Math.max(widthHres, heightHres) / Math.max(widthLres, heightLres);

        var x1L = parseInt(x1H / thumbProp);
        var y1L = parseInt(y1H / thumbProp);
        var x2L = parseInt(x2H / thumbProp);
        var y2L = parseInt(y2H / thumbProp);

        return [x1L, y1L, x2L, y2L];
    },

    calculateHresCrop: function (image, lresCrop) {
        var x1H = parseInt(lresCrop[0]);
        var y1H = parseInt(lresCrop[1]);
        var x2H = parseInt(lresCrop[2]);
        var y2H = parseInt(lresCrop[3]);

        var widthHres = parseInt(image.width);
        var heightHres = parseInt(image.height);
        var widthLres = parseInt(image["lres-width"]);
        var heightLres = parseInt(image["lres-height"]);

        // Rapporto fra alta e bassa risoluzione
        var thumbProp = Math.max(widthHres, heightHres) / Math.max(widthLres, heightLres);

        var x1L = parseInt(x1H * thumbProp);
        var y1L = parseInt(y1H * thumbProp);
        var x2L = parseInt(x2H * thumbProp);
        var y2L = parseInt(y2H * thumbProp);

        return [x1L, y1L, x2L, y2L];
    },

    rotateCrop: function (crop, imageW, imageH, rotation) {
        var x1H = crop[0];
        var y1H = crop[1];
        var x2H = crop[2];
        var y2H = crop[3];
        var swap;
        switch (rotation) {
            case 90:
                swap = x1H;
                x1H = imageW - y2H - y1H;
                y1H = swap;
                swap = x2H;
                x2H = y2H;
                y2H = swap;
                break;
            case 180:
                x1H = imageW - x2H - x1H;
                y1H = imageH - y2H - y1H;
                break;
            case 270:
                swap = x1H;
                x1H = y1H;
                y1H = imageH - swap - x2H;
                swap = y2H;
                y2H = x2H;
                x2H = swap;
                break;
            default:
                break;
        }

        return [x1H, y1H, x2H, y2H];
    },

    clearCanvas: function (canvasElement) {
        if (typeof canvasElement !== 'object' || canvasElement.length < 1) {
            return;
        }

        var context = canvasElement.getContext('2d');
        context.save();

        context.setTransform(1, 0, 0, 1, 0, 0);
        context.clearRect(0, 0, canvasElement.width, canvasElement.height);

        context.restore();
    },

    drawImageOnCanvas: function (imageData, canvasElement) {
        var lresUrl = this.getUrl(imageData.photoId, "web");

        if (typeof lresUrl !== "string" || lresUrl.length < 1 || typeof canvasElement !== 'object' || canvasElement.length < 1) {
            return;
        }

        var image = new Image();

        //Rut - 23/09/2016 - hash di sicurezza se la vista non è cambiata - se il load dell'immagine ci mette troppo tempo
        image.onload = function imageOnLoad() {
            // IMPORTANTE!!! assegnazione proprietà w e h direttamente dentro oggetto html canvas - altrimenti non
            // funzionerà il resize
            var canvasW = canvasElement.width;
            var canvasH = canvasElement.height;
            canvasElement.width = canvasW;
            canvasElement.height = canvasH;

            var ctx = canvasElement.getContext('2d');
            ctx.clearRect(0, 0, canvasW, canvasH);
            /*
             * EarlTP - 17-07-2018: fix scarsa qualita dei canvas, specialmente se piccoli (vedi collage con tante foto)
             * vedi: https://www.html5rocks.com/en/tutorials/canvas/hidpi/
             */
            var devicePixelRatio = window.devicePixelRatio || 1;
            var backingStoreRatio = ctx.webkitBackingStorePixelRatio ||
                ctx.mozBackingStorePixelRatio ||
                ctx.msBackingStorePixelRatio ||
                ctx.oBackingStorePixelRatio ||
                ctx.backingStorePixelRatio || 1;
            var ratio = devicePixelRatio / backingStoreRatio;

            //-- Upscale del canvas se i 2 ration non sono uguali
            if (devicePixelRatio !== backingStoreRatio) {
                var oldWidth = canvasElement.width;
                var oldHeight = canvasElement.height;

                canvasElement.width = oldWidth * ratio;
                canvasElement.height = oldHeight * ratio;

                canvasElement.style.width = oldWidth + 'px';
                canvasElement.style.height = oldHeight + 'px';

                // now scale the context to counter
                // the fact that we've manually scaled
                // our canvas element
                ctx.scale(ratio, ratio);
            }

            var lowResPoints = imageData["lres-crop"];

            var x1L = parseInt(lowResPoints[0]);
            var y1L = parseInt(lowResPoints[1]);
            var x2L = parseInt(lowResPoints[2]);
            var y2L = parseInt(lowResPoints[3]);

            //Gestione rotazione extra col canvas
            var extraRotation = parseInt(imageData.extraRotation);

            // Origine di inizio disegno nel canvas
            var dx = 0, dy = 0, dw = canvasW, dh = canvasH;
            if (extraRotation > 0) {
                // Salvataggio contesto non ruotato per eventuali redraw successivi
                // ctx.save();

                // Sposta origine di disegno al centro (sarà l'origine della rotazione)
                ctx.translate((canvasW / 2), (canvasH / 2));

                ctx.rotate(extraRotation * Math.PI / 180);

                // Anche le dimensioni vanno ruotate se è rotazione di 90 o 270 gradi
                if ([90, 270].indexOf(extraRotation) > -1) {
                    dw = canvasH;
                    dh = canvasW;
                    dx = -(canvasH / 2);
                    dy = -(canvasW / 2);
                } else {
                    dx = -(canvasW / 2);
                    dy = -(canvasH / 2);
                }

            }

            ctx.drawImage(image, x1L, y1L, x2L, y2L, dx, dy, dw, dh);

            // Eventuali altri disegni con l'origine riportata com'era all'inizio
            // Resetta orientamento normale canvas con la matrice 'identità'
            ctx.setTransform(1, 0, 0, 1, 0, 0);
        };

        // Segnalazione caricamento errore canvas
        image.onerror = function imageOnError() {
            console.error("errore generazione canvas")
        };

        // Start image loading
        image.src = lresUrl;
    },
};
